export default "__VITE_ASSET__db6638fb__"